import { Button, Popconfirm, Space, Tag } from "antd";
import { DeleteFilled, EditFilled, UserSwitchOutlined } from "@ant-design/icons";

const columnsType = (
    editAction,
    deleteAction,
    filter = {
        area: [],
        authuser: {},
    }
) => {
    return [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 140,

            render: (text) => <span>{text}</span>,
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
        },
        {
            title: "Correo",
            dataIndex: "email",
            key: "email",
            width: 140,
            sorter: (a, b) => {
                if (a.email < b.email) {
                    return -1;
                }
                if (a.email > b.email) {
                    return 1;
                }
                return 0;
            },
        },
        {
            title: "Rol",
            dataIndex: "rol",
            key: "rol",
            width: 130,
            sorter: (a, b) => {
                if (a.rol < b.rol) {
                    return -1;
                }
                if (a.rol > b.rol) {
                    return 1;
                }
                return 0;
            },
        },
        {
            title: "Posición",
            dataIndex: "position",
            key: "position",
            width: 150
        },
        {
            title: "Area",
            dataIndex: "area",
            key: "area",
            width: 170,
            render: (_, record) => {
                const areasItem = record.area.map((are, index) => {
                    const findColor = filter.area.find((dataArea) => are.areaUserId === dataArea.uid);
                    let color = findColor ? findColor.color : "red";
                    let nameArea = findColor ? findColor.text : are.name;
                    return (
                        <Tag color={color} key={`${are}--${index}`}>
                            {nameArea}
                        </Tag>
                    );
                });
                return <>{areasItem}</>;
            },
            filters: filter.area,
            onFilter: (value, record) => {
                const areas = record.area.map((area) => area.name);
                return areas.includes(value);
            },
        },
        {
            title: "Recibe correos",
            dataIndex: "emailRecived",
            key: "emailRecived",
            width: 120,
            filters: [
                { text: "Si", value: true },
                { text: "No", value: false },
            ],
            onFilter: (value, record) => {
                return record.isEmailList === value;
            },
            render: (_, record) => {
                let item = (
                    <Tag color={"magenta"}>No</Tag>
                );
                if (record.isEmailList) {
                    item = (
                        <Tag color={"geekblue"}>Sí</Tag>
                    );
                }
                return item;
            },
        },
        {
            title: "Editar",
            key: "editar",
            width: 170,
            render: (_, record) => {
                const isEqualEmail = filter.authuser === record.email;
                if (!record.isActive) {
                    return (<>
                        {!isEqualEmail && (
                            <Popconfirm title="¿Reactivar Usuario?" onConfirm={() => deleteAction(_.email)}>
                                <Button type="text" icon={<UserSwitchOutlined />} />
                            </Popconfirm>
                        )}
                    </>);
                } else {
                    return (
                        <Space size="middle">
                            <>
                                <Button
                                    type="text"
                                    icon={<EditFilled />}
                                    onClick={() => {
                                        editAction(record);
                                    }}
                                />
                                {!isEqualEmail && (
                                    <Popconfirm okText="Si" cancelText="Cancelar" title="¿Estás seguro de desactivar?" onConfirm={() => deleteAction(_.email)}>
                                        <Button type="text" icon={<DeleteFilled />} />
                                    </Popconfirm>
                                )}
                            </>
                        </Space>
                    );
                }
            },
        },
    ];
};

export const columnsUser = (
    editAction,
    deleteAction,
    filters = {
        area: [],
        authuser: {},
    }
) => {
    const columns = columnsType(editAction, deleteAction, filters);
    return {
        columns,
    };
};
